export default "__VITE_PUBLIC_ASSET__cc459b86__"